import cheeky from "@images/icons/badges/icon-cheeky-coverage.webp";
import cheekyAdjustable from "@images/icons/badges/icon-adjustable-coverage.webp";
import medium from "@images/icons/badges/icon-moderate-coverage.webp";
import tease from "@images/icons/badges/icon-tease-coverage.webp";
import modest from "@images/icons/badges/icon-high-waisted.webp";
import highRise from "@images/icons/badges/icon-high-rise.webp";
import midRise from "@images/icons/badges/icon-mid-rise.webp";
import lowRise from "@images/icons/badges/icon-low-rise.webp";
import highLegCut from "@images/icons/badges/icon-high-leg.webp";
import trueToSize from "@images/icons/badges/icon-true-to-size.webp";
import small from "@images/icons/badges/icon-size-down.webp";
import big from "@images/icons/badges/icon-size-up.webp";
import adequateSupport from "@images/icons/badges/icon-extra-support.webp";
import minimalSupport from "@images/icons/badges/icon-light-support.webp";
import adjustableStraps from "@images/icons/badges/icon-adjustable-straps.webp";
import adjustableCups from "@images/icons/badges/icon-adjustable-cups.webp";
import underwire from "@images/icons/badges/icon-builtin-underwire.webp";
import removablePadding from "@images/icons/badges/icon-removable-padding.webp";
import tieBack from "@images/icons/badges/icon-tie-back.webp";
import tieFront from "@images/icons/badges/icon-tie-front.webp";
import lightWeight from "@images/icons/badges/icon-light-weight.webp";
import quickDrying from "@images/icons/badges/icon-quick-drying.webp";
import figureHugging from "@images/icons/badges/icon-figure-hugging.webp";
import fourWayStretch from "@images/icons/badges/icon-four-way-stretch.webp";

export const staticBadges = [
    {
        id: "cheeky-coverage",
        badgeIcon: cheeky,
        badgeLabel: "CHEEKY COVERAGE",
    },
    {
        id: "cheeky-adjustable",
        badgeIcon: cheekyAdjustable,
        badgeLabel: "CHEEKY ADJUSTABLE",
    },
    {
        id: "medium-coverage",
        badgeIcon: medium,
        badgeLabel: "MEDIUM COVERAGE",
    },
    {
        id: "tease-coverage",
        badgeIcon: tease,
        badgeLabel: "TEASE COVERAGE",
    },
    {
        id: "modest-coverage",
        badgeIcon: modest,
        badgeLabel: "MODEST COVERAGE",
    },
    {
        id: "high-rise",
        badgeIcon: highRise,
        badgeLabel: "HIGH-RISE",
    },
    {
        id: "mid-rise",
        badgeIcon: midRise,
        badgeLabel: "MID-RISE",
    },
    {
        id: "low-rise",
        badgeIcon: lowRise,
        badgeLabel: "LOW-RISE",
    },
    {
        id: "high-leg-cut",
        badgeIcon: highLegCut,
        badgeLabel: "HIGH-LEG CUT",
    },
    {
        id: "runs-true-to-size",
        badgeIcon: trueToSize,
        badgeLabel: "RUNS TRUE TO SIZE",
    },
    {
        id: "runs-small",
        badgeIcon: small,
        badgeLabel: "RUNS SMALL",
    },
    {
        id: "runs-big",
        badgeIcon: big,
        badgeLabel: "RUNS BIG",
    },
    {
        id: "adequate-support",
        badgeIcon: adequateSupport,
        badgeLabel: "ADEQUATE SUPPORT",
    },
    {
        id: "minimal-support",
        badgeIcon: minimalSupport,
        badgeLabel: "MINIMAL SUPPORT",
    },
    {
        id: "adjustable-straps",
        badgeIcon: adjustableStraps,
        badgeLabel: "ADJUSTABLE STRAPS",
    },
    {
        id: "adjustable-cups",
        badgeIcon: adjustableCups,
        badgeLabel: "ADJUSTABLE CUPS",
    },
    {
        id: "built-in-underwire",
        badgeIcon: underwire,
        badgeLabel: "BUILT-IN UNDERWIRE",
    },
    {
        id: "removable-padding",
        badgeIcon: removablePadding,
        badgeLabel: "REMOVABLE PADDING",
    },
    {
        id: "tie-back",
        badgeIcon: tieBack,
        badgeLabel: "TIE-BACK",
    },
    {
        id: "tie-front",
        badgeIcon: tieFront,
        badgeLabel: "TIE-FRONT",
    },
    {
        id: "lightweight",
        badgeIcon: lightWeight,
        badgeLabel: "LIGHTWEIGHT",
    },
    {
        id: "quick-drying",
        badgeIcon: quickDrying,
        badgeLabel: "QUICK-DRYING",
    },
    {
        id: "figure-hugging",
        badgeIcon: figureHugging,
        badgeLabel: "FIGURE-HUGGING",
    },
    {
        id: "4-way-stretch",
        badgeIcon: fourWayStretch,
        badgeLabel: "4-WAY STRETCH",
    },
];
